export default "__VITE_ASSET__a60468c4__"